export default __webpack_public_path__ + "static/media/wedding-couple.979fac64.svg";